/* istanbul ignore file */
import type {CustomCssVarsFnParams} from '@wix/wixstores-client-storefront-common';
import {ImageRatio} from '../../../constants';

export const getImageRatio = (ratioEnum: number): number => {
  switch (ratioEnum) {
    case ImageRatio.THREE_BY_TWO:
      return 3 / 2;
    case ImageRatio.FOUR_BY_THREE:
      return 4 / 3;
    case ImageRatio.ONE_BY_ONE:
      return 1;
    case ImageRatio.THREE_BY_FOUR:
      return 3 / 4;
    case ImageRatio.TWO_BY_THREE:
      return 2 / 3;
    case ImageRatio.AUTO:
    default:
      return 1;
  }
};

export const getProductGalleryLayoutCustomCssVars = ({styleParams}: CustomCssVarsFnParams) => {
  const thumbnailsSize = styleParams.numbers.productPage_thumbnailsSize ?? 45;
  const thumbnailImageRatio = styleParams.numbers.productPage_thumbnailImageRatio ?? ImageRatio.ONE_BY_ONE;
  const thumbnailsContainerSpacing = 15;
  const thumbnailArea = thumbnailsSize + thumbnailsContainerSpacing;

  const actualRatio = getImageRatio(thumbnailImageRatio);
  const thumbnailsHeight = thumbnailsSize / actualRatio;

  return {
    productPage_thumbnailsHeight: `${thumbnailsHeight}px`,
    productPage_thumbnailArea: `${thumbnailArea}px`,
  };
};
